module.exports = __webpack_public_path__ + "static/media/Mascot_ddory_jpg.937ffea0.jpg";